import { useState, useRef, cloneElement } from "react";
import { FaArrowRight } from "react-icons/fa";
import { GrUpdate } from "react-icons/gr";
import { IoQrCodeSharp } from "react-icons/io5";
import { GoPlusCircle, GoPencil } from "react-icons/go";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { ReferralModal } from "./../ReferralModal";
import QRCode from "qrcode.react";
import ActionsSkeleton from "../../../LoadingActions/ActionsLoader";
import TakePaymentModal from "../../../../pages/PrivateService/TakePaymentModal";
import PrescriptionModal from "../../../../pages/PrivateService/PrescriptionModal";
import PatientBooking from "./../PatientTemplateDEMDx/components/PatientBooking";
import {
  MdOutlineEmail,
  MdOutlineAttachMoney,
  MdOutlineSchedule,
  MdOutlineContactPage,
} from "react-icons/md";
import { PiMagicWandLight } from "react-icons/pi";
import { IoAddCircleOutline } from "react-icons/io5";
import PatientAIChatbot from "./components/PatientAIChatbot";
import useTitanApp from "../../../../hooks/useTitanApp";
import CustomButton from "../../../controls/CustomButton";
import { MdOutlineClose } from "react-icons/md";
import VaccinationModal from "../../../../pages/PrivateService/VaccinationModal";
import {
  SaveAIChatMessage,
  updateConsultationActions,
  setChatBotReferralLetter,
  setChatQuestions,
  setIsChatReferralLetter,
  setPatientAIChatMessages,
  setPatientChatAnswersLoader,
  setShowAddVitalsModal,
  setOpenSignatureDialog,
  getConsultationAuditTimeline,
  setCurrentOpenVitalsModal,
  setOpenVaccineDialog,
  setVaccineDetails,
  setOpenBookingDialog,
  setOpenRefDialog,
  setBookingDetails,
  setLetterDetails,
  setReferralLetter,
  setOpenPrescriptionDialog,
  setDynamicPrescriptions,
  setPrescriptionId,
  setIsPrescriptionUpdate,
  setQuickActionsTabSwitch,
  trackServiceBilling,
  setIncrementVaccineCompleted,
  setIncrementPrescriptionCompleted,
  setIncrementBookingCompleted,
  setPatientSummary,
  setUpdateAppointmentAIChatMessage,
  setPendingCalculatorId,
} from "../../../../dispatchers/patientDispatchers";
import { getCalculatorById } from "./dosageCalculators/registry";
import { Tooltip } from "@mui/material";
import { BsFillSendFill, BsThreeDots } from "react-icons/bs";
import { generateAnswerUrl } from "../../../../apiUrls/apiUrls";
import AiStreamResponse from "../../../../utils/AiStreamResponse";
import { BookingModal } from "../../../Scheduler/schedule/BookingModal";
import { addScheduleEvent } from "../../../../dispatchers/scheduleEventsDispatchers";
import { ActionType } from "@/enum/ActionType";
import { parse, addMinutes, format } from "date-fns";
import { v4 as uuidv4 } from "uuid";
import removeActionFromLocal from "@/utils/removeFromLocalStorage";
import { getCompanyVaccineByCompanyId } from "../../../../dispatchers/nmsDispatchers";
import { FiArrowRight } from "react-icons/fi";
import { FaSyringe } from "react-icons/fa";
import { BiCapsule } from "react-icons/bi";
import { MdOutlineCalendarToday } from "react-icons/md";
import { MdOutlinePayment } from "react-icons/md";
import { FaCheckSquare } from "react-icons/fa";
import { GrDocumentText } from "react-icons/gr";
import PrescriptionPreviewModal from "../PrescriptionPreviewModal";
import VaccinationPreviewModal from "../VaccinationPreviewModal";
import VaccineConfirmationModal from "../VaccineConfirmationModal";
import React, { useEffect } from "react";
import { FiPenTool } from "react-icons/fi";
import SignatureModal from "../../../../pages/PrivateService/SignatureModal";
import { Tabs, Tab } from "@mui/material";
import { motion } from "framer-motion";
import { setTogglePatientPanelOne } from "../../../../dispatchers/patientDispatchers";
import { LuPanelLeftOpen } from "react-icons/lu";
import { ConsultationTimeline } from "../../ConsultationTimeline";
import { ActionsPanel } from "./components/ActionsPanel";
import { AddActionPopover } from "./components/AddActionPopover";
import { SummaryDocumentCustom } from "./components/SummaryDocumentCustom";
import { trackFirstTimeIntercomEvent } from "@/utils/trackFirstTimeIntercomEvent";
import {
  accessTitanverseCalenderUpsert,
  accessTitanversePrescriptionUpsert,
} from "@/data/constantStrings";
import { checkUserPermissions } from "@/utils/checkUserPermissions";
import { toTherapyLevelNumber } from "@/features/patientSlice/patientSlice";
import { setShowPermissionModal } from "@/dispatchers/appDispatchers";
// Helper function to map actionId to action type
const mapActionIdToType = (actionId) => {
  const typeMap = {
    1: "prescription",
    2: "payment",
    3: "referral",
    4: "appointment",
    5: "vitals",
    6: "vaccine",
    7: "consultation",
    8: "signature",
    9: "document",
    10: "image",
    11: "prescription-draft",
    12: "vaccine-draft",
  };
  return typeMap[actionId] || "consultation";
};

// Check if details contain base64 image data
const isBase64ImageData = (details) => {
  if (typeof details === "string") {
    return (
      details.includes("data:image") ||
      details.startsWith("/9j/") ||
      details.startsWith("iVBORw0KGgo")
    );
  }
  return false;
};

// Transform AI chat success messages to PharmacistAction format
const transformSuccessMessagesToActions = (chatMessages) => {
  if (!chatMessages || !Array.isArray(chatMessages)) {
    return [];
  }

  return chatMessages
    .filter((msg) => msg.sender === "success")
    .map((msg, index) => ({
      id: `${msg.actionId || index}-${Date.now()}`,
      type: mapActionIdToType(msg.actionId),
      description: msg.message || "Action completed",
      timestamp: msg.timestamp || new Date().toISOString(),
      details: typeof msg.details === "string" ? msg.details : undefined,
      status: "completed",
      data:
        msg.details && typeof msg.details === "object"
          ? msg.details
          : undefined,
      actionId: msg.actionId,
    }));
};

const PatientQuickActions = () => {
  const {
    patientState,
    appState,
    templateState,
    memberState,
    pharmacyServiceState,
    documentState,
  } = useTitanApp();

  const {
    darkMode,
    companyId,
    currentPharmacyId,
    currentPharmacy,
    currentUser,
  } = appState;
  const { isTemplateSelected } = templateState;
  const {
    patientSummary,
    patientSummaryLoader,
    selectedPatientDetails,
    patientVitals,
    patientConditionRelated,
    patientMedications,
    patientAllergies,
    patientAIChatMessages,
    patientChatAnswersLoader,
    prescriptionCompleted,
    paymentCompleted,
    referralCompleted,
    bookingCompleted,
    vitalsCompleted,
    vaccineCompleted,
    showPrescriptionPreviewModal,
    selectedPatientConsultation,
    isConsultationEnabled,
    showVaccinationPreviewModal,
    showVaccineConfirmationModal,
    isSummaryStreaming,
    demDXForChat,
    consultationId,
    togglePatientPanelOne,
    togglePatientPanelTwo,
    firstPatientPanelTitle,
    bookingDetails,
    openVaccineDialog,
    openBookingDialog,
    openRefDialog,
    openPrescriptionDialog,
    quickActionsTabSwitch,
    patientSummaryForActions,
    summaryDocumentId,
    patientConsentSignature,
    patientReferalLetter,
    referralLetter,
    chatBotReferralLetter,
    isSummaryLetterLoading,
    patientConsultationLoader,
    isgetPatientConsentSignatureLoading,
    patientDocumentsConultaion,
    pendingCalculatorId,
  } = patientState || {};
  const { userProfiles } = memberState || {};
  const { pharmacyDetails, pharmacyContactDetails } =
    pharmacyServiceState || {};
  const { documentById, isDocumentLoading } = documentState;

  const isConsultationCompleted =
    selectedPatientConsultation?.consultationStatus === 1;
  // const [value, setValue] = useState(0);
  const QUICK_ACTIONS_KEY = (consultationId) =>
    `quick_actions_${consultationId}`;

  const handleChange = async (event, newValue) => {
    if (quickActionsTabSwitch !== newValue) {
      setQuickActionsTabSwitch(newValue);
      if (quickActionsTabSwitch === 0) {
        await getConsultationAuditTimeline(consultationId);
      }
    }
  };

  const [question, setQuestion] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [openQrDialog, setOpenQrDialog] = useState(false);
  const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
  const [openBookingAppointment, setOpenBookingAppointment] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [showAddActionPopover, setShowAddActionPopover] = useState(false);
  const [pharmacistActions, setPharmacistActions] = useState([]);
  const [showSummaryDocument, setShowSummaryDocument] = useState(false);
  const [showAddActionButton, setShowAddActionButton] = useState(true);
  const [manualCalculators, setManualCalculators] = useState([]);
  const typingIntervalRef = useRef(null);
  const fullResponseRef = useRef("");
  const lastSavedContentRef = useRef("");
  const [currentAIUpdate, setCurrentAIUpdate] = useState(null);

  const handleSaveMessage = async (patientAIMessages) => {
    if (patientAIMessages?.length === 0) return;
    const currentContent = JSON.stringify(patientAIMessages).replace(/\n/g, "");

    const payload = {
      ConsultationId: consultationId || "",
      ConsultationChat: currentContent,
    };
    await SaveAIChatMessage(payload);
    lastSavedContentRef.current = currentContent;
  };

  const chatBoxRef = useRef(null);
  useEffect(() => {
    if (!consultationId) return;

    if (patientSummary?.Actions?.length) return;

    try {
      const storedActions = localStorage.getItem(
        QUICK_ACTIONS_KEY(consultationId),
      );

      if (storedActions) {
        setPatientSummary({
          ...(patientSummary || {}),
          Actions: JSON.parse(storedActions),
        });
      }
    } catch (e) {
      console.error("Failed to load quick actions", e);
    }
  }, [consultationId]);
  useEffect(() => {
    if (!consultationId) return;
    if (!patientSummary?.Actions?.length) return;

    try {
      localStorage.setItem(
        QUICK_ACTIONS_KEY(consultationId),
        JSON.stringify(patientSummary.Actions),
      );
    } catch (e) {
      console.error("Failed to save quick actions", e);
    }
  }, [patientSummary?.Actions, consultationId]);

  const currentBooking = React.useMemo(() => {
    if (!bookingDetails) return undefined;
    try {
      let details;
      if (typeof bookingDetails === "string") {
        details = JSON.parse(bookingDetails);
      } else if (bookingDetails.payload) {
        details =
          typeof bookingDetails.payload === "string"
            ? JSON.parse(bookingDetails.payload)
            : bookingDetails.payload;
      } else {
        details = bookingDetails;
      }

      let appointmentDate = details.date || "";
      let appointmentTime = details.time || "";

      if (!appointmentDate || !appointmentTime) {
        if (details.startDate) {
          const d = new Date(details.startDate);
          if (!isNaN(d.getTime())) {
            if (!appointmentDate) {
              appointmentDate = `${d.getUTCFullYear()}-${String(
                d.getUTCMonth() + 1,
              ).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
            }
            if (!appointmentTime) {
              appointmentTime = `${String(d.getUTCHours()).padStart(
                2,
                "0",
              )}:${String(d.getUTCMinutes()).padStart(2, "0")}`;
            }
          }
        }
      }

      const rawPharmacist =
        details.resourceId ||
        details.ResourceId ||
        details.pharmacist ||
        details.pharmacistId ||
        details.userId ||
        "";

      const rawPharmacistName =
        details.pharmacistName ||
        details.pharmacist ||
        "";

      const rawServiceType =
        details.serviceID ||
        details.serviceId ||
        details.serviceType ||
        details.serviceTypeId ||
        "";

      return {
        id: details.id || bookingDetails._originalAppointmentId || "",
        patientId:
          details.patientID ||
          details.patientId ||
          selectedPatientDetails?.patientID ||
          "",
        patientName:
          `${selectedPatientDetails?.foreName || ""} ${
            selectedPatientDetails?.surName || ""
          }`.trim() ||
          selectedPatientDetails?.patientName ||
          "",
        pharmacist: rawPharmacist,
        resourceId: rawPharmacist,
        ResourceId: rawPharmacist,
        pharmacistName: rawPharmacistName,
        serviceType: rawServiceType,
        serviceId: rawServiceType,
        serviceID: rawServiceType,
        date: appointmentDate,
        time: appointmentTime,
        duration: parseInt(details.duration || "30", 10),
        room: details.RoomId || details.room || "",
        roomId: details.RoomId || details.roomId || "",
        RoomId: details.RoomId || details.roomId || "",
        notes: details.name || details.notes || "",
        email: details.email || selectedPatientDetails?.email || "",
        contactNumber:
          details.mobile ||
          selectedPatientDetails?.mobile ||
          selectedPatientDetails?.contacts?.find((c) => !!c.value)?.value ||
          "",
        confirmationMethod: details.confirmationMethod || undefined,
        tasksToComplete: details.tasksToComplete || [],
        vaccinesAdminister: details.vaccinesAdminister || [],
      };
    } catch (e) {
      console.error("Error parsing bookingDetails for BookingModal:", e);
      return undefined;
    }
  }, [bookingDetails, selectedPatientDetails]);

  const handleBookingSave = async (data) => {
    if (isConsultationCompleted) return;

    let existingId = null;
    let existingConsultationId = null;

    if (bookingDetails) {
      try {
        let parsedDetails;
        if (typeof bookingDetails === "string") {
          parsedDetails = JSON.parse(bookingDetails);
        } else if (bookingDetails.payload) {
          parsedDetails =
            typeof bookingDetails.payload === "string"
              ? JSON.parse(bookingDetails.payload)
              : bookingDetails.payload;
        } else {
          parsedDetails = bookingDetails;
        }

        existingId =
          parsedDetails?.id ||
          bookingDetails?._originalAppointmentId ||
          parsedDetails?._originalAppointmentId;
        existingConsultationId = parsedDetails?.consultationID;
      } catch (e) {
        console.error("Failed to parse bookingDetails:", e);
      }
    }

    const gmtDate = parse(
      `${data?.date} ${data?.time}`,
      "yyyy-MM-dd HH:mm",
      new Date(),
    );

    const startDateTime = new Date(
      gmtDate.getTime() - gmtDate.getTimezoneOffset() * 60000,
    );
    const endDateTime = addMinutes(
      startDateTime,
      parseInt(data?.duration || "0", 10) || 0,
    );

    let appointmentId;
    let appointmentConsultationId;

    if (existingConsultationId) {
      appointmentId = existingId;
      appointmentConsultationId = existingConsultationId;
    } else {
      const newId = uuidv4();
      appointmentId = newId;
      appointmentConsultationId = newId;
    }

    const appointment = {
      id: appointmentId,
      consultationID: appointmentConsultationId,
      name: data?.notes || "",
      patientID:
        data?.patientId ||
        selectedPatientDetails?.patientID ||
        selectedPatientDetails?.patientId ||
        "",
      startDate: startDateTime.toISOString(),
      endDate: endDateTime.toISOString(),
      duration: parseInt(data?.duration || "0", 10) || 0,
      durationUnit: "m",
      cls: "",
      recurrenceRule: "",
      exceptionDates: [],
      resourceId: data?.pharmacist || "",
      allDay: false,
      scheduleEventType: 1,
      appointmentType: data?.appointmentType || 1,
      serviceID: data?.serviceType || "",
      email: data?.email || "",
      mobile: data?.mobile || "",
      confirmationMethod: data?.confirmationMethod || "",
      RoomId: data?.room || "",
      recordedAt: new Date().toLocaleString(),
      tasksToComplete: data?.tasksToComplete || [],
      vaccinesAdminister: data?.vaccinesAdminister || [],
      IsNotify: true,
    };

    const appointmentPayload = {
      payload: JSON.stringify(appointment),
      actionName: ActionType[4],
      actionNumber: "4",
      isPerformed: true,
      performedAt: new Date().toISOString(),
    };

    const appointmentMessageId = `appointment-${Date.now()}-${Math.random()
      .toString(36)
      .substr(2, 9)}`;

    // 1. Primary Appointment creation API
    await addScheduleEvent(appointment, currentPharmacyId);

    // 2. Additional Consultation Quick Actions APIs & state updates
    if (consultationId) {
      await updateConsultationActions({
        consultationId: consultationId,
        payload: appointmentPayload,
      });

      const consultationChatPayload = {
        ConsultationChat: JSON.stringify([
          {
            sender: "success",
            message: "Appointment booked successfully.",
            actionId: 4,
            details: {
              payload: JSON.stringify(appointmentPayload),
              actionName: "BookAppointment",
              actionNumber: "4",
              isPerformed: true,
              performedAt: new Date().toISOString(),
            },
          },
        ]),
        ConsultationId: consultationId,
      };

      await SaveAIChatMessage(consultationChatPayload);

      setUpdateAppointmentAIChatMessage({
        sender: "success",
        message: "Booking completed successfully.",
        actionId: 4,
        details: appointmentPayload,
        timestamp: new Date().toISOString(),
        appointmentMessageId: appointmentMessageId,
        originalConsultationId: consultationId,
      });

      removeActionFromLocal(consultationId, "4");
      setIncrementBookingCompleted(true);
    }
  };

  const handleAppointmentSaved = (appointmentData) => {
    const appointmentMessageId = `appointment-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

    const newMessage = {
      sender: "success",
      message: "Booking completed successfully.",
      actionId: 4,
      details: appointmentData,
      timestamp: new Date().toISOString(),
      appointmentMessageId: appointmentMessageId,
    };

    setUpdateAppointmentAIChatMessage(newMessage);
  };
  const capitalizeKeys = (obj) => {
    const newObj = {};
    for (const key in obj) {
      const capitalKey = key.charAt(0).toUpperCase() + key.slice(1);
      newObj[capitalKey] = obj[key];
    }
    return newObj;
  };

  const actionIcons = {
    prescription: <IoAddCircleOutline className="icons-color" size={18} />,
    payment: <MdOutlineAttachMoney className="icons-color" size={18} />,
    letter: <MdOutlineEmail className="icons-color" size={18} />,
    schedule: <MdOutlineSchedule className="icons-color" size={18} />,
    inquiry: <MdOutlineContactPage className="icons-color" size={18} />,
  };

  const actionIconsById = {
    1: <BiCapsule size={18} />,
    2: <MdOutlinePayment size={18} />,
    3: <GrDocumentText size={18} />,
    4: <MdOutlineCalendarToday size={18} />,
    5: <MdOutlineContactPage size={18} />,
    6: <FaSyringe size={18} />,
    7: <MdOutlineContactPage size={18} />,
  };

  const getActionIconById = (id, isCompleted) => {
    const icon = actionIconsById[id] || <MdOutlineContactPage size={18} />;

    if (isCompleted) {
      return cloneElement(icon, {
        fill: "#1da64f",
        color: "#1da64f",
      });
    } else {
      return cloneElement(icon, {
        // color: "#999999",
        className: "icons-color",
      });
    }
  };
  const getActionIcon = (title = "") => {
    const name = title.toLowerCase();
    if (name.includes("prescription")) return actionIcons.prescription;
    if (name.includes("payment")) return actionIcons.payment;
    if (name.includes("letter")) return actionIcons.letter;
    if (name.includes("schedule")) return actionIcons.schedule;
    if (name.includes("inquiry")) return actionIcons.inquiry;
    return actionIcons.inquiry;
  };
  const prescriptionOptions = [
    {
      id: 1,
      label: "Create prescription",
      icon: <GoPlusCircle fill="#999999" />,
    },
    {
      id: 2,
      label: "Process payment",
      icon: <GoPlusCircle fill="#999999" />,
    },
    {
      id: 3,
      label: "Send referral letter",
      icon: <GoPlusCircle fill="#999999" />,
    },
    {
      id: 4,
      label: "Book an appointment",
      icon: <GoPlusCircle fill="#999999" />,
    },
    {
      id: 5,
      label: "Record vitals",
      icon: <GoPlusCircle fill="#999999" />,
    },
    {
      id: 6,
      label: "Administer vaccination",
      icon: <GoPlusCircle fill="#999999" />,
    },
    {
      id: 7,
      label: "General",
      icon: <GoPlusCircle fill="#999999" />,
    },
    {
      id: 8,
      label: "Patient Signature",
      icon: <GoPlusCircle fill="#999999" />,
    },
  ];
  const handleSubmit = (e) => {
    e.preventDefault();
    setQuestion("");
    setChatQuestions("");
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleClostRefDialog = () => {
    setOpenRefDialog(false);
  };
  const handleClosePaymentDialog = () => {
    setOpenPaymentDialog(false);
  };
  const handleClosePrescriptionDialog = () => {
    setOpenPrescriptionDialog(false);
  };
  const handleCloseQrDialog = () => {
    setOpenQrDialog(false);
  };

  const handleClostBookAppointment = () => {
    setOpenBookingAppointment(false);
  };
  const handleCloseVaccineDialog = () => {
    setOpenVaccineDialog(false);
  };
  const handleCloseSignatureDialog = () => {
    setOpenSignatureDialog({ open: false });
  };

  const getActions = (actionNumber) => {
    const number = Number(actionNumber);
    if (isConsultationEnabled) return;
    switch (number) {
      case 1:
        if (!checkUserPermissions(accessTitanversePrescriptionUpsert)) {
          setShowPermissionModal(true);
          return;
        }
        return setOpenPrescriptionDialog(true);
      case 2:
        return setOpenPaymentDialog(true);
      case 3:
        return setOpenRefDialog(true);
      case 4:
        if (!checkUserPermissions(accessTitanverseCalenderUpsert)) {
          setShowPermissionModal(true);
          return;
        }
          return;
      case 5:
        return setCurrentOpenVitalsModal({
          isEdit: false,
        });
      case 6:
        getCompanyVaccineByCompanyId(companyId);
        return setOpenVaccineDialog(true);
      case 7:
        // Not implemented yet, leave untouched
        return;
      default:
        // fallback, do nothing
        return;
    }
  };

  const handleAddManualCalculator = (calculator) => {
    setManualCalculators([calculator]);
  };

  useEffect(() => {
    if (pendingCalculatorId) {
      const calculator = getCalculatorById(pendingCalculatorId);
      if (calculator) {
        handleAddManualCalculator(calculator);
        setShowAddActionButton(false);
      }
      setPendingCalculatorId(null);
    }
  }, [pendingCalculatorId]);

  const handleRemoveManualCalculator = (calculatorId) => {
    setShowAddActionButton(true);
    setManualCalculators((prev) => prev.filter((c) => c.id !== calculatorId));
  };

  const handleCloseBookingDialog = () => {
    setOpenBookingDialog(false);
    setBookingDetails(null);
  };

  const handleChatInput = (e) => {
    setQuestion(e.target.value);
    setChatQuestions(e.target.value);
  };

  const scrollToBottom = () => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  };

  function getDefaultActionText(actionNumber) {
    switch (actionNumber) {
      case "1":
        return null; // We'll handle DrugCode separately
      case "2":
        return "Proceed to payment gateway";
      case "3":
        return "Generate referral letter";
      case "4":
        return "Schedule an appointment";
      case "5":
        return "Take vitals: BP, weight, height";
      case "6":
        return "Check patient's vaccination history";
      case "7":
        return "Perform additional clinical actions";
      default:
        return null;
    }
  }

  const handleSend = async () => {
    trackFirstTimeIntercomEvent({
      eventName: "ask_me_anything_used_first_time",
      user: {
        id: currentUser.emailAddress,
        email: currentUser.emailAddress,
        name: currentUser.fullName,
      },
      properties: {
        source: "consultation_quick_actions_chatbot",
      },
    });

    const chatModel = {
      prompt: question.trim(),
      patientDetailsModelForChat: {
        dob: selectedPatientDetails?.dob,
        sex: selectedPatientDetails?.sex,
        ethnicity: selectedPatientDetails?.ethnicity,
        patientVitals: patientVitals,
        allergies: patientAllergies,
        vaccines: [],
        conditionRelated: patientConditionRelated,
        // The chat schema only accepts the numeric therapyLevel (0-4), not the enum name.
        medications: (patientMedications || []).map((medication) => ({
          ...medication,
          therapyLevel: toTherapyLevelNumber(medication?.therapyLevel),
        })),
      },
    };
    setPatientChatAnswersLoader(true);
    if (!question.trim()) return;
    const userMessage = {
      sender: "user",
      type: "text",
      message: question.trim(),
    };
    let patientAIMessages = [{ type: "append", message: userMessage }];
    setPatientAIChatMessages({ type: "append", message: userMessage });
    setQuestion("");
    setChatBotReferralLetter("");

    let aiMessage = {
      sender: "ai",
      type: "text",
      message: "",
    };

    setPatientAIChatMessages({ type: "append", message: aiMessage });
    patientAIMessages.push({ type: "append", message: aiMessage });
    setIsTyping(true);
    fullResponseRef.current = "";

    await AiStreamResponse(
      chatModel,
      (chunk) => {
        fullResponseRef.current += chunk;

        if (!typingIntervalRef.current) {
          let index = 0;
          typingIntervalRef.current = setInterval(() => {
            if (index < fullResponseRef.current.length) {
              const currentText = fullResponseRef.current.slice(0, index + 1);
              setPatientAIChatMessages({
                type: "updateLast",
                message: {
                  ...aiMessage,
                  message: currentText,
                },
              });
              const updateObj = {
                type: "updateLast",
                message: {
                  ...aiMessage,
                  message: currentText,
                },
              };
              setCurrentAIUpdate(updateObj);
              scrollToBottom();
              index++;
            } else {
              clearInterval(typingIntervalRef.current);
              typingIntervalRef.current = null;
              setIsTyping(false);
            }
          }, 20);
        }
      },

      async () => {
        if (!typingIntervalRef.current) setIsTyping(false);
        setPatientChatAnswersLoader(false);

        try {
          const cleanedResponse = fullResponseRef.current
            .replace(/\{\s*"Actions":[\s\S]*?\}/g, "") // remove JSON blocks
            .replace(/\n+/g, "\n") // normalize new lines
            .trim();
          const finalMessage = {
            type: "append",
            message: {
              ...aiMessage,
              message: cleanedResponse,
            },
          };

          const finalPayload = [
            ...patientAIMessages.filter(
              (msg) => msg?.message?.message?.trim() !== "",
            ),
            finalMessage,
          ];

          const transformedMessages = finalPayload.map((item) => ({
            sender: item?.message?.sender,
            message: item?.message?.message,
          }));

          await trackServiceBilling({
            companyId,
            consultationId,
            pharmacyId: currentPharmacyId,
            actiontype: "aicall",
          });

          await trackServiceBilling({
            companyId,
            consultationId,
            pharmacyId: currentPharmacyId,
            actiontype: "aichat",
          });

          await handleSaveMessage(transformedMessages);
        } catch (err) {
          console.error("Error calling trackServiceBilling:", err);
        }
      },

      generateAnswerUrl(),
    );
  };

  const handleEnterPressed = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      await handleSend();
      // await handleSaveMessage();
    }
  };

  const getCompletedActionText = (actionId) => {
    switch (actionId) {
      case 1:
        return "Prescription completed for patient";
      case 2:
        return "Payment processed for patient";
      case 3:
        return "Letter generated for patient";
      case 4:
        return "Appointment booked for patient";
      case 5:
        return "Vitals recorded for patient";
      case 6:
        return "Vaccine administered to patient";
      case 7:
        return "Action completed for patient";
      default:
        return "Action completed for patient";
    }
  };

  const availableActions = (patientSummary?.Actions || [])?.filter((action) => {
    const actionId = Number(action?.ActionNumber);
    if (actionId === 1 && prescriptionCompleted) return false;
    if (actionId === 2 && paymentCompleted) return false;
    if (actionId === 3 && referralCompleted) return false;
    if (actionId === 4 && bookingCompleted) return false;
    // Allow multiple vitals additions (e.g., Weight Loss Calculator outputs several vitals).
    // if (actionId === 5 && vitalsCompleted) return false;
    if (actionId === 6 && vaccineCompleted) return false;
    return true;
  });

  return (
    <>
      <motion.div
        className="pc-sections third-section"
        animate={{
          width:
            togglePatientPanelOne && togglePatientPanelTwo
              ? "100%"
              : togglePatientPanelOne || togglePatientPanelTwo
                ? "48.5%"
                : "33.33%",
        }}
        transition={{ duration: 0.5, type: "spring", stiffness: "60" }}
      >
        <>
          <Tabs
            value={quickActionsTabSwitch}
            onChange={handleChange}
            aria-label="Tabs"
          >
            <Tab label={<span className="tabs_text">Actions</span>} />
            <Tab label={<span className="tabs_text">Chat</span>} />
            <Tab label={<span className="tabs_text">Audit</span>} />
          </Tabs>

          <div className="content qa-audit">
            {quickActionsTabSwitch === 0 && (
              <div className="flex flex-col flex-1 h-full">
                <div className="flex flex-col flex-1 overflow-hidden">
                  <ActionsPanel
                    isDarkMode={darkMode}
                    patientSummary={patientSummary}
                    selectedPatientDetails={selectedPatientDetails}
                    prescriptionCompleted={prescriptionCompleted}
                    paymentCompleted={paymentCompleted}
                    referralCompleted={referralCompleted}
                    bookingCompleted={bookingCompleted}
                    vitalsCompleted={vitalsCompleted}
                    vaccineCompleted={vaccineCompleted}
                    isConsultationEnabled={isConsultationEnabled}
                    pharmacistActions={pharmacistActions}
                    setPharmacistActions={setPharmacistActions}
                    onActionComplete={(actionType, data) => {
                      setPharmacistActions((prev) => [
                        ...prev,
                        {
                          id: Date.now().toString(),
                          type: actionType,
                          data,
                          timestamp: new Date(),
                        },
                      ]);
                    }}
                    onDeleteAction={(actionId) => {
                      setPharmacistActions((prev) =>
                        prev.filter((a) => a.id !== actionId),
                      );
                    }}
                    getActionIconById={getActionIconById}
                    getActions={getActions}
                    patientAIChatMessages={patientAIChatMessages}
                    patientChatAnswersLoader={patientChatAnswersLoader}
                    isTyping={isTyping}
                    chatBoxRef={chatBoxRef}
                    completedConsultationActions={
                      selectedPatientConsultation?.actions
                    }
                    manualCalculators={manualCalculators}
                    onRemoveManualCalculator={handleRemoveManualCalculator}
                    selectedPatient={selectedPatientDetails}
                    setShowAddActionButton={setShowAddActionButton}
                  />
                </div>
                {showAddActionButton && (
                  <div
                    className={`border-t sticky bottom-0 pb-4 z-10 ${
                      darkMode ? "bg-[#121212]" : "bg-white"
                    }`}
                  >
                    <AddActionPopover
                      isDarkMode={darkMode}
                      showAddActionPopover={showAddActionPopover}
                      setShowAddActionPopover={setShowAddActionPopover}
                      selectedPatient={selectedPatientDetails}
                      companyId={companyId}
                      setOpenPrescriptionDialog={setOpenPrescriptionDialog}
                      setOpenPaymentDialog={setOpenPaymentDialog}
                      setOpenRefDialog={setOpenRefDialog}
                      setOpenBookingDialog={setOpenBookingDialog}
                      setShowAddVitalsModal={setShowAddVitalsModal}
                      setOpenVaccineDialog={setOpenVaccineDialog}
                      setOpenSignatureDialog={setOpenSignatureDialog}
                      setShowSummaryDocument={() =>
                        setShowSummaryDocument(true)
                      }
                      setDynamicPrescriptions={setDynamicPrescriptions}
                      setPrescriptionId={setPrescriptionId}
                      setIsPrescriptionUpdate={setIsPrescriptionUpdate}
                      setCurrentOpenVitalsModal={setCurrentOpenVitalsModal}
                      setVaccineDetails={setVaccineDetails}
                      setLetterDetails={setLetterDetails}
                      setReferralLetter={setReferralLetter}
                      setBookingDetails={setBookingDetails}
                      setIsChatReferralLetter={setIsChatReferralLetter}
                      getCompanyVaccineByCompanyId={
                        getCompanyVaccineByCompanyId
                      }
                      setIncrementPrescriptionCompleted={
                        setIncrementPrescriptionCompleted
                      }
                      setIncrementVaccineCompleted={
                        setIncrementVaccineCompleted
                      }
                      onActionComplete={(actionType, data) => {
                        setPharmacistActions((prev) => [
                          ...prev,
                          {
                            id: Date.now().toString(),
                            type: actionType,
                            data,
                            timestamp: new Date(),
                          },
                        ]);
                      }}
                      consultationId={consultationId}
                      onSelectCalculator={handleAddManualCalculator}
                      consultationCompletedActions={
                        selectedPatientConsultation?.actions
                      }
                      setShowAddActionButton={setShowAddActionButton}
                    />
                  </div>
                )}
              </div>
            )}

            {quickActionsTabSwitch === 1 && (
              <>
                <div className="pc-sections quick-actions">
                  <div className="quick-actions-body">
                    {patientSummaryLoader ? (
                      <div style={{ width: "100%", padding: "20px" }}>
                        <ActionsSkeleton />
                      </div>
                    ) : (
                      <div className="quick-actions-container">
                        <PatientAIChatbot
                          chatMessages={chatMessages}
                          isTyping={isTyping}
                          chatBoxRef={chatBoxRef}
                          getActions={getActions}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="quick-actions-footer">
                  <div className="ask-me-anything">
                    <form
                      onSubmit={handleSubmit}
                      className="ask-me-anything-form"
                    >
                      <input
                        value={question}
                        onChange={(e) => handleChatInput(e)}
                        onKeyDown={handleEnterPressed}
                        placeholder="Ask me anything"
                        disabled={
                          isTyping ||
                          isConsultationEnabled ||
                          isSummaryStreaming ||
                          isConsultationCompleted
                        }
                      />
                    </form>
                  </div>
                </div>
              </>
            )}

            {quickActionsTabSwitch === 2 && <ConsultationTimeline />}
          </div>
        </>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: {
              backgroundColor: darkMode ? "#222" : "#fff",
              borderRadius: "16px",
            },
          }}
        >
          <DialogContent>
            {patientSummary?.Actions?.length > 0 && (
              <div className="quick-actions-container compact-actions">
                <div className="quick-actions-wrapper">
                  {patientSummary?.Actions?.map((action, index) => {
                    const actionId = Number(
                      action?.ActionNumber || action?.actionNumber,
                    );
                    const isCompleted =
                      (actionId === 1 && prescriptionCompleted) ||
                      (actionId === 2 && paymentCompleted) ||
                      (actionId === 3 && referralCompleted) ||
                      (actionId === 4 && bookingCompleted) ||
                      (actionId === 5 && vitalsCompleted) ||
                      (actionId === 6 && vaccineCompleted);

                    return (
                      <div
                        className={`action-item ${
                          isCompleted ? "completed" : ""
                        }`}
                        key={index}
                        onClick={() => {
                          if (!isCompleted) {
                            setOpenDialog(false);
                            setIsChatReferralLetter(false);
                            getActions(
                              action?.ActionNumber ||
                                action?.actionNumber ||
                                "",
                            );
                          }
                        }}
                      >
                        <div className="compact-action-head">
                          <div className="compact-action-heading">
                            {getActionIconById(actionId, isCompleted)}
                            <p>{action?.ActionName || action?.actionName}</p>
                          </div>
                          {isCompleted ? (
                            <FaCheckSquare fill="#16c60c" size={18} />
                          ) : (
                            <FiArrowRight
                              className="arrow"
                              color={darkMode ? "#fff" : "#0a0a0a"}
                            />
                          )}
                        </div>
                        <div className="compact-action-desc">
                          <p className="desc">
                            {action?.Description || action?.description}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="suggested-prescription-section">
              <h4>Actions</h4>
              {prescriptionOptions
                .filter((item) => item.id !== 2 && item.id !== 7) // for the mean time hide process payment and general action
                .map((item, index) => (
                  <div
                    className="suggested-prescription-item"
                    key={index}
                    onClick={() => {
                      setOpenDialog(false);

                      if (item?.id === 1) {
                        setOpenPrescriptionDialog(true);
                        setDynamicPrescriptions([
                          {
                            id: Date.now(),
                            value: "",
                            quantity: "",
                            dose: "",
                            notes: "",
                            prescribedItemId: "",
                          },
                        ]);
                        setPrescriptionId("");
                        setIsPrescriptionUpdate(false);
                        setIncrementPrescriptionCompleted(false);
                      }
                      if (item?.id === 2) {
                        setOpenPaymentDialog(true);
                      }
                      if (item?.id === 3) {
                        setOpenRefDialog(true);
                        setLetterDetails(null);
                        setReferralLetter(null);
                        setIsChatReferralLetter(false);
                      }
                      if (item?.id === 4) {
                        setOpenBookingDialog(true);
                        setBookingDetails(null);
                      }
                      if (item?.id === 5) {
                        setShowAddVitalsModal(true);
                        setCurrentOpenVitalsModal({
                          isEdit: false,
                        });
                      }
                      if (item?.id === 6) {
                        setVaccineDetails(null);
                        getCompanyVaccineByCompanyId(companyId);
                        setOpenVaccineDialog(true);
                        setIncrementVaccineCompleted(false);
                      }
                      if (item?.id === 9) {
                        setShowSummaryDocument({
                          open: true,
                          viewMode: false,
                          details: null,
                        });
                      }
                      if (item?.id === 8) {
                        setOpenSignatureDialog({
                          open: true,
                          viewMode: false,
                          details: null,
                        });
                      }
                    }}
                  >
                    <span>{item.label}</span>
                    {item.icon}
                  </div>
                ))}
            </div>
          </DialogContent>
        </Dialog>
        <ReferralModal
          open={openRefDialog}
          onOpenChange={(value) => {
            if (!value) {
              handleClostRefDialog();
            }
            setOpenRefDialog(value);
          }}
          onClose={handleClostRefDialog}
          initialTitle={
            referralLetter?.title ||
            chatBotReferralLetter?.title ||
            patientReferalLetter?.title
          }
          initialSubject={
            referralLetter?.subject ||
            chatBotReferralLetter?.subject ||
            patientReferalLetter?.subject
          }
          initialContent={
            referralLetter?.content ||
            chatBotReferralLetter?.content ||
            patientReferalLetter?.content ||
            patientReferalLetter?.referalLetter?.content ||
            ""
          }
          patientName={
            `${selectedPatientDetails?.foreName || ""} ${
              selectedPatientDetails?.surName || ""
            }`.trim() ||
            selectedPatientDetails?.patientName ||
            ""
          }
          patientEmail={selectedPatientDetails?.email}
        />
        <Dialog
          open={openQrDialog}
          onClose={handleCloseQrDialog}
          maxWidth={false}
          PaperProps={{
            sx: {
              backgroundColor: darkMode ? "#222" : "#fff",
              borderRadius: "16px",
              width: "30vw",
              height: "36vh",
            },
          }}
        >
          <DialogContent className="action_qr_dialog" sx={{ padding: "16px" }}>
            <div className="actions_qr_code">
              <QRCode value={"www.google.com"} size={200} />

              <h3>Scan QR to upload images</h3>
            </div>
            <div className="qr_code_description">
              <p>
                Upload videos and photos to this consultation by scanning the
                barcode
              </p>
              <CustomButton
                action={handleCloseQrDialog}
                className={"actions_qr_btn"}
                label={"Done"}
              />
            </div>
          </DialogContent>
        </Dialog>

        <BookingModal
          isOpen={Boolean(openBookingDialog)}
          onOpenChange={(open) => {
            if (!open) {
              handleCloseBookingDialog();
            }
          }}
          onCancel={handleCloseBookingDialog}
          mode={currentBooking ? "edit" : "create"}
          booking={currentBooking}
          initialPatientName={
            `${selectedPatientDetails?.foreName || ""} ${
              selectedPatientDetails?.surName || ""
            }`.trim() ||
            selectedPatientDetails?.patientName ||
            ""
          }
          initialPatientId={String(
            selectedPatientDetails?.patientID ||
              selectedPatientDetails?.patientId ||
              "",
          )}
          initialPatientEmail={selectedPatientDetails?.email || ""}
          initialPatientPhone={
            selectedPatientDetails?.mobile ||
            selectedPatientDetails?.contacts?.find((c) => !!c.value)?.value ||
            ""
          }
          initialPharmacistName={
            currentBooking?.pharmacistName || currentBooking?.pharmacist || ""
          }
          isDarkMode={darkMode}
          shouldRefreshAppointments={false}
          onSave={handleBookingSave}
        />

        <TakePaymentModal
          show={openPaymentDialog}
          handleClose={handleClosePaymentDialog}
        />

        <PrescriptionModal
          show={openPrescriptionDialog}
          handleClose={handleClosePrescriptionDialog}
          isDarkMode={darkMode}
        />

        <VaccinationModal
          show={openVaccineDialog}
          handleClose={handleCloseVaccineDialog}
        />

        {showPrescriptionPreviewModal && <PrescriptionPreviewModal />}

        {showVaccinationPreviewModal && <VaccinationPreviewModal />}

        {showVaccineConfirmationModal && (
          <VaccineConfirmationModal
            setOpenVaccineDialog={setOpenVaccineDialog}
          />
        )}

        <SignatureModal
          handleClose={handleCloseSignatureDialog}
          isDarkMode={darkMode}
        />

        <SummaryDocumentCustom
          isOpen={showSummaryDocument}
          onClose={() => setShowSummaryDocument(false)}
          patientName={selectedPatientDetails?.patientName || ""}
          patientNHS={selectedPatientDetails?.nhsNumber || ""}
          patientEmail={selectedPatientDetails?.email}
          pharmacistName={currentUser?.fullName || ""}
          actions={[
            ...transformSuccessMessagesToActions(patientAIChatMessages),
            ...pharmacistActions,
          ]}
          patientAIChatMessages={patientAIChatMessages}
          isDarkMode={darkMode}
          onDocumentGenerated={(documentData) => {}}
          onEmailSent={() => {}}
          selectedPatientDetails={selectedPatientDetails}
          consultationId={consultationId}
          consultationCompletedActions={selectedPatientConsultation?.actions}
          userProfiles={userProfiles}
          patientSummaryForActions={patientSummaryForActions}
          summaryDocumentId={summaryDocumentId}
          currentPharmacy={currentPharmacy}
          pharmacyContactDetails={pharmacyContactDetails}
          patientConsentSignature={patientConsentSignature}
          documentById={documentById}
          patientReferalLetter={patientReferalLetter}
          isSummaryLetterLoading={isSummaryLetterLoading}
          showPatientConsultationsLoader={patientConsultationLoader}
          isDocumentLoading={isDocumentLoading}
          isPatientSignatureLoading={isgetPatientConsentSignatureLoading}
          patientDocumentsConultaion={patientDocumentsConultaion}
        />
      </motion.div>
    </>
  );
};

export default PatientQuickActions;
